import { SUB_VIEW_MODEL } from '../Model/Models';
import ManageApp from './Functionality/ManageApp';
import DiningAttendance from './SubComponents/DiningAttendance';
import TotalMeals from "./SubComponents/TotalMeals";
import DepartmentPolicies from './SubComponents/DepartmentPolicies';
import Settings from './SubComponents/Settings';
import { permissionObj } from '../../../../Helpers/permission';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 * @description
 * This component conditionally renders either the DepartmentAccess or DiningAttendance subview
 * based on the current value of `subView`. It handles configuration and data passing for managing
 * department access and dining attendance functionalities.
 *
 * @param {string} subView - Current active view (e.g., DEPARTMENT_ACCESS or DINING_ATTENDANCE).
 * @param {Function} setSubView - Function to change the current subview.
 * @param {Function} setBodyForExport - Function to set the data body to be exported.
 * @param {Array} finalArray - Final array of records displayed or exported.
 * @param {Function} setFinalArray - Function to update the finalArray.
 * @param {string} searchElement - Current value of the search input.
 * @param {Function} setSearchElement - Function to update the search input value.
 * @param {Function} setSearch - Function to trigger a search action.
 * @param {string} simpleSearch - Simple search string input.
 * @param {Function} setSimpleSearch - Function to update the simpleSearch string.
 * @param {Function} cleanAdvance - Function to reset or clean advanced filters.
 * @param {JSX.Element|null} render - Optional extra element to be rendered (e.g., pagination).
 * @param {Function} setRender - Function to update the render content.
 * @param {Object} selectedOption - Object representing the current selected filter or option.
 * @param {Function} setSelectedOption - Function to update the selected option.
 *
 * @returns {JSX.Element}
 */
const Manage = ({
                    subView,
                    setSubView,
                    subViewChild,
                    setSubViewChild,
                    criteria,
                    setCriteria,
                    setBodyForExport,
                    finalArray,
                    setFinalArray,
                    searchElement,
                    setSearchElement,
                    setSearch,
                    simpleSearch,
                    setSimpleSearch,
                    render,
                    setRender,
                    selectedOption,
                    setSelectedOption,
                    setModuleId,
                    option,
                    setOption,
                    modified,
                    setModified,
                    DEV,
                    permission,
                    search,
                }) => {

    const {
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        color,
        setColor
    } = ManageApp({
        setSubView,
        setSearchElement,
        setFinalArray,
        setSelectedOption,
        setModuleId,
        setOption,
        subView,
        setBodyForExport,
        setCriteria,
        setSearch
    });


    return (<>
        { color?.id &&
            <>
                {subView === SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE && ( DEV || permission?.includes(permissionObj?.WEB_FOODIE_ATTENDANCE_READ) ) &&
                    <DiningAttendance
                        subView={subView}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                        setCriteria={setCriteria}
                        finalArray={finalArray}
                        setFinalArray={setFinalArray}
                        setBodyForExport={setBodyForExport}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        render={render}
                        setRender={setRender}
                        color={color}
                        modified={modified}
                        setModified={setModified}
                        search={search}
                    />
                }
                {subView === SUB_VIEW_MODEL.MANAGE.SETTINGS  && ( DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_READ) ) &&
                    <Settings
                        subView={subView}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                        color={color}
                        setColor={setColor}
                    />
                }
                {subView === SUB_VIEW_MODEL.MANAGE.DEPARTMENT_POLICIES  && ( DEV || permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_READ) ) &&
                    <DepartmentPolicies
                        subView={subView}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                    />
                }
                {subView === SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS && ( DEV || permission?.includes(permissionObj?.WEB_TOTAL_MEALS_READ) ) &&
                    <TotalMeals
                        option={option}
                        subView={subView}
                        subViewChild={subViewChild}
                        setSubViewChild={setSubViewChild}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                        finalArray={finalArray}
                        setFinalArray={setFinalArray}
                        setBodyForExport={setBodyForExport}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        setRender={setRender}
                        criteria={criteria}
                        setCriteria={setCriteria}
                        modified={modified}
                        setModified={setModified}
                    />
                }
            </>
        }
    </>)
}

export default Manage;
